/**
 * Clases globales estables para items del menú.
 *
 * Next 16 / Turbopack cambió el naming de CSS Modules
 * (`MenuItem_megamenu…` → `MenuItem-module-scss-module__…`). El CSS del
 * admin Magento que coloreaba categorías (p. ej. Ofertas) apuntaba al hash
 * viejo y dejó de aplicar. Estas clases no dependen del bundler.
 *
 * Selectores recomendados en admin:
 *   .megamenu-cms-item--ofertas > a,
 *   .megamenu-cms-item--ofertas > span { color: …; }
 *   o por atributo: [data-menu-url-key="ofertas"]
 */

const UNSAFE_SLUG_CHARS = /[^a-z0-9_-]+/g

type MenuItemIdentity = {
    url_key?: string | null
    url_path?: string | null
}

export const getMenuItemSlug = (item: MenuItemIdentity): string | undefined => {
    const raw =
        item.url_key?.trim() ||
        item.url_path?.split('/').filter(Boolean).pop() ||
        ''

    const slug = raw
        .toLowerCase()
        .replace(UNSAFE_SLUG_CHARS, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '')

    return slug || undefined
}

export const isEspaciosCasaMenuItem = (
    slug?: string,
    name?: string | null
): boolean => {
    if (slug === 'espacio-de-la-casa' || slug === 'espacios-de-la-casa') {
        return true
    }
    if (slug?.includes('espacio-de-la-casa')) return true

    const normalized = (name ?? '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
    return /espacio[s]?\s+de\s+la\s+casa/.test(normalized)
}

export const getMenuItemStableClassNames = (item: MenuItemIdentity): string => {
    const slug = getMenuItemSlug(item)
    return slug
        ? `megamenu-cms-item megamenu-cms-item--${slug}`
        : 'megamenu-cms-item'
}
